import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SpecialRequestService} from './special-request.service';
import {SpecialRequestField} from './special-request-field.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {SpecialRequest} from './special-request.model';
import {DWPValidatorsService} from '../dwpvalidators.service';
import {SweetUtil} from '../components/commons/sweet/sweet-util-service';

@Component({
  selector: 'app-special-request',
  templateUrl: './special-request.component.html',
  styleUrls: ['./special-request.component.css']
})
export class SpecialRequestComponent implements OnInit {

  @Input()
  includeEuroPlusFields;
  @Input()
  disabled: boolean;
  @Output()
  specialRequestEmitter: EventEmitter<SpecialRequest> = new EventEmitter<SpecialRequest>();
  savedFileAbsolutePath: string;
  supportingDocument: File;
  specialRequestFields: Array<SpecialRequestField>;
  form: FormGroup;
  selectedFileFormControl = new FormControl();
  readonly allowedFileTypes: string[] = ['.csv', '.pdf', '.docx', '.jpg', '.png', '.eml', '.odt', '.msg', '.htm'];
  private readonly FILE_TYPE_ERROR: string = 'Selected file type is not supported';
  private readonly FILE_SIZE_ERROR: string = 'Selected file is empty';

  constructor(private service: SpecialRequestService, private formBuilder: FormBuilder, private validators: DWPValidatorsService,
              private sweetUtil: SweetUtil) {

    this.form = formBuilder.group({
      specialRequestFields: new FormControl('', Validators.required),
      requirements: new FormControl('', [Validators.required, validators.notBlank, Validators.maxLength(500)]),
      justification: new FormControl('', [Validators.required, validators.notBlank, Validators.maxLength(500)]),
    });
  }

  ngOnInit(): void {
    this.service.specialRequestFields().subscribe((specialRequestFields) => {
      this.specialRequestFields = this.includeEuroPlusFields ? specialRequestFields :
        specialRequestFields.filter((specialRequestField) => specialRequestField.name !== 'acceptance-euro-plus');
    });
  }

  emit(): void {
    const selectedSpecialRequestFields = this.form.get('specialRequestFields').value;
    const specialRequestFields = [];

    if (Array.isArray(selectedSpecialRequestFields)) {
      selectedSpecialRequestFields.forEach((specialRequestField) => {
        if (specialRequestField) {
          specialRequestFields.push(specialRequestField);
        } else {
          // Skipped
        }

      });
    } else {
      if (selectedSpecialRequestFields) {
        specialRequestFields.push(selectedSpecialRequestFields);
      } else {
        // Skipped
      }
    }

    const specialRequest: SpecialRequest = {
      id: undefined,
      declineReason: undefined,
      justification: this.form.get('justification').value,
      specialRequestFields,
      supportingMaterialFilePath: this.savedFileAbsolutePath,
      supportingMaterialFileName: this.supportingDocument ? this.supportingDocument.name : undefined,
      requirements: this.form.get('requirements').value,
      messageRead: undefined,
      ownerInitials: undefined,
      lastName: undefined,
      vin: undefined,
      contractNumber: undefined,
      dateModified: undefined
    };
    if (this.form.valid && specialRequestFields && specialRequestFields.length > 0) {
      this.specialRequestEmitter.emit(specialRequest);
    } else {
      this.specialRequestEmitter.emit(null);
    }
  }

  invalidField(fieldName: string): boolean {
    return this.form.get(fieldName).dirty && !this.form.get(fieldName).valid;
  }

  selectSupportingDocument(supportingDocuments: FileList) {
    if (supportingDocuments) {
      const selectedFile = supportingDocuments.item(0);
      this.prepareFile(selectedFile);
    }
  }

  saveSupportingDocument(): void {
    this.service.saveSupportingDocument(this.supportingDocument).subscribe((savedFilePath) => {
      this.savedFileAbsolutePath = savedFilePath;
      this.emit();
      SweetUtil.showSuccess('Upload Successful');
    }, (error) => {
      if (error?.status === 200 && error?.error?.text) {
        this.savedFileAbsolutePath = error.error.text;
        this.emit();
        SweetUtil.showSuccess('Upload Successful');
      } else {
        this.sweetUtil.showError(`Upload Failed`);
      }
    });
  }

  private prepareFile(selectedFile: File) {
    if (selectedFile.size === 0 || !this.isFileTypeAllowed(selectedFile)) {
      this.selectedFileFormControl.reset();
      this.sweetUtil.showError(selectedFile.size === 0 ? this.FILE_SIZE_ERROR : this.FILE_TYPE_ERROR);
      return;
    }

    this.supportingDocument = selectedFile;
  }

  private isFileTypeAllowed(file: File): boolean {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    return fileExtension ? this.allowedFileTypes.includes('.' + fileExtension) : false;
  }

}
